module.exports = __webpack_public_path__ + "static/Background-mp-4.47e6b7a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Background-mp-4.jpg
// module id = 114
// module chunks = 133428282160390 225901961288281